<template>
  <div class="settings-card">
    <div
      class="settings-card__header"
      role="button"
      tabindex="0"
      @click="toggleContent"
      @keydown.enter="toggleContent"
      @keydown.space.prevent="toggleContent"
    >
      <div class="settings-card__title">
        <span class="settings-card__title-text">{{ title }}</span>
        <span @click.stop>
          <Tooltip
            v-if="$slots.tooltip || $scopedSlots.tooltip"
            :position="'bottom'"
            :position-mob="'left'"
            :max-width="tooltipMaxWidth"
          >
            <template #trigger>
              <img
                :src="require('@/assets/img/account/settings/infoTooltip.svg')"
                class="settings-card__title-help"
                alt="info"
              />
            </template>
            <template #content>
              <slot name="tooltip" />
            </template>
          </Tooltip>
        </span>
      </div>

      <button type="button" class="settings-card__collapse-btn" @click.stop="toggleContent">
        <img
          :src="require('@/assets/img/account/settings/collapseArrow.svg')"
          alt=""
          class="settings-card__collapse-icon"
          :class="{ 'settings-card__collapse-icon--open': isContentOpen }"
        />
      </button>
    </div>

    <div class="settings-card__subtitle">
      {{ subtitle }}
    </div>

    <VExpandTransition>
      <div v-show="isContentOpen" class="settings-card__content">
        <slot />
      </div>
    </VExpandTransition>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import Tooltip from '@/components/common/Tooltip.vue';

export default {
  name: 'SettingsCard',
  components: { Tooltip },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    tooltipMaxWidth: {
      type: Number,
      default: 700,
    },
  },
  setup() {
    const isContentOpen = ref(false);

    const toggleContent = () => {
      isContentOpen.value = !isContentOpen.value;
    };

    return {
      isContentOpen,
      toggleContent,
    };
  },
};
</script>

<style lang="scss" scoped>
.settings-card {
  border: 1px solid #DDDDDD;
  border-radius: 10px;
  padding: 24px;
  margin-bottom: 20px;
  max-width: 860px;

  @media screen and (max-width: 768px) {
    padding: 16px;
    margin-bottom: 16px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
  }

  &__title {
    color: #212121;
    font-size: 18px;
    line-height: 100%;
    display: flex;
    align-items: center;
    gap: 10px;

    @media screen and (max-width: 768px) {
      font-size: 22px;
      line-height: 100%;
    }

    @media screen and (max-width: 480px) {
      font-size: 18px;
    }
  }

  &__title-text {
    display: inline-block;
  }

  &__title-help {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  &__subtitle {
    margin-top: 8px;
    color: #707070;
    font-size: 14px;
    font-weight: 400;
    line-height: 120%;
    width: 100%;

    @media screen and (max-width: 768px) {
      font-size: 14px;
      line-height: 120%;
    }
  }

  &__collapse-btn {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;
  }

  &__collapse-icon {
    display: block;
    transition: transform 0.25s ease;

    &--open {
      transform: rotate(180deg);
    }
  }
}
</style>
